<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table">
    <div class="row" style="margin-bottom: 10px;">
        <div class="col-12">
            <app-tab [tabs]="tabs" [(selectedKey)]="selectedTab" (onTabSelected)="onLoad()" (onRefresh)="onLoad()" />
        </div>
    </div>
    <app-templates *ngIf="selectedTab == '1'" [ctryCode]="ctryCode" [businessId]="businessId"
        [interactionType]="interactionType" />
    <app-printer-template-map *ngIf="selectedTab == '2'" [ctryCode]="ctryCode" [businessId]="businessId" />
</div>